<template>
  <section class="bg-terms">
    <div class="home">
      <HeaderGlobal :secondaryHeader="false" :qtSomos="qtSomos" />
      <!-- Page Content Desktop -->
      <div class="container-fluid" >
        <div class="container container-content border-left-light pt-md-5 pb-5">
          <div class="row">
            <div @click="backToHome()"
                 :style="btnColor"
                 class="back-icon"> 
              <img style="height: 25px;" src="/static/assets/img/back-to-home-icon.png">
            </div>
            <div class="col-lg-12 pl-md-5 pr-md-0 px-0 text-first-color" v-html="regulationText">
            </div>
          </div>
        </div>
      </div>

      <FooterGlobal :secondaryFooter="false" :qtSomos="qtSomos" />
    </div>
  </section>
</template>
<script>
import HeaderGlobal from "./HeaderGlobal.vue";
import FooterGlobal from "./FooterGlobal.vue";
import { utils } from "../services/Survey.js";
const u = new utils();

export default {
  name: "Regulation",
  components: {
    HeaderGlobal,
    FooterGlobal,
  },
  data: () => ({
    qtSomos: 0
  }),
  computed: {
    regulationText() {
      return this.$store.state.regulationText
    },
    template() {
      if (Object.keys(this.$store.state.template).length) {
        return this.$store.state.template;
      }
      return false
    },
    btnColor() {
      if (this.template && this.template.style.surveyBtnColor) {
        return { background: this.template.style.surveyBtnColor }
      } else if (this.template && this.template.style.firstColor) {
        return { background: this.template.style.firstColor }
      } else return {}
    }
  },
  async created() {
    this.qtSomos = this.$store.state.qtUsers;
    if(!this.qtSomos){
      await this.getTemplateByFullDomain();
      this.qtSomos = this.$store.state.qtUsers;
    }
  },
  beforeMount() {
    // if (!this.$store.state.template.style) {
    //   this.$nextTick(() => {
    //     this.$router.push('home')
    //   })
    // }
  },
  methods: {
    backToHome() {
      this.$router.push('/')
    },
    setDocumentStylesFromTemplate() {
			if (this.template.style.fontFamilyP) {
				document.documentElement.style.setProperty(
					"--font-family-p",
					this.template.style.fontFamilyP
				);
			}
			if (this.template.style.fontFamilyH1) {
				document.documentElement.style.setProperty(
					"--font-family-h1",
					this.template.style.fontFamilyH1
				);
			}
			if (this.template.style.fontFamilyTitles) {
				document.documentElement.style.setProperty(
					"--font-family-titles",
					this.template.style.fontFamilyTitles
				);
			}
			if (this.template.style.fontFamilyGeneral) {
				document.documentElement.style.setProperty(
					"--font-family-general",
					this.template.style.fontFamilyGeneral
				);
			}
			document.documentElement.style.setProperty(
				"--first-color",
				this.template.style.firstColor
			);
			document.documentElement.style.setProperty(
				"--second-color",
				this.template.style.secondColor
			);
			document.documentElement.style.setProperty(
				"--survey-text-color",
				this.template.style.surveyTextColor
			);
			document.documentElement.style.setProperty(
				"--bg-image",
				this.template.style.bgImage
			);
			document.documentElement.style.setProperty(
				"--bg-gradient-color",
				this.template.style.bgGradientColor
			);
			document.documentElement.style.setProperty(
				"--bg-fallback-color",
				this.template.style.bgFallbackColor
			);
			document.documentElement.style.setProperty(
				"--bg-filter",
				this.template.style.bgFilter
			);
			document.documentElement.style.setProperty(
				"--btn-text-color",
				this.template.style.btnTextColor
			);
			document.documentElement.style.setProperty(
				"--home-title-size",
				this.template.style.homeTitleSize
			);
			document.documentElement.style.setProperty(
				"--home-title-height",
				this.template.style.homeTitleHeight
			);
			if (this.template.style.homeSubtitleSize) {
				document.documentElement.style.setProperty(
					"--home-subtitle-size",
					this.template.style.homeSubtitleSize
				);
			}
			if (this.template.style.homeSubtitleStyle) {
				document.documentElement.style.setProperty(
					"--home-subtitle-style",
					this.template.style.homeSubtitleStyle
				);
			}
			if (this.template.style.homeSubtitleHeight) {
				document.documentElement.style.setProperty(
					"--home-subtitle-height",
					this.template.style.homeSubtitleHeight
				);
			}
			if (this.template.style.surveyBtnTextColor) {
				document.documentElement.style.setProperty(
					"--btn-text-color-survey",
					this.template.style.surveyBtnTextColor
				);
			} else {
				document.documentElement.style.setProperty(
					"--btn-text-color-survey",
					this.template.style.btnTextColor
				);
			}
			if (this.template.style.surveyBtnColor) {
				document.documentElement.style.setProperty(
					"--btn-color",
					this.template.style.surveyBtnColor
				);
			} else {
				document.documentElement.style.setProperty(
					"--btn-color",
					this.template.style.firstColor
				);
			}
			document.documentElement.style.setProperty(
				"--bg-filter",
				this.template.style.bgFilter
			);
		},
    setMetaDataFromTemplate() {
			document.title = this.template.meta.title;
			const descEl = document.querySelector('head meta[name="description"]');
			descEl.setAttribute("content", this.template.meta.desc);
			if (this.template.meta.favicon) {
				const favicon = document.querySelector("link[rel~='icon']");
				favicon.setAttribute("href", this.template.meta.favicon);
			}
		},
    async getTemplateBySubdomain() {
			if (this.$store.state.prjName) {
				this.prjName = this.$store.state.prjName;
				this.domainName = this.$store.state.domainName;
			} else {
				const host = window.location.host;
				const parts = host.split(".");

				if (host.includes("localhost")) {
					this.prjName = "nacaoalvinegra2";
					this.domainName = "fanbase";
				} else {
					if (host.endsWith(".br")) {
						if (parts[0] === "www") {
							this.prjName = "default";
							this.domainName = parts[1];
						} else if (parts.length === 4) {
							this.prjName = parts[0];
							this.domainName = parts[1];
						} else {
							this.prjName = "default";
							this.domainName = parts[0];
						}
					} else {
						if (parts[0] === "www") {
							this.prjName = "default";
							this.domainName = parts[1];
						} else if (parts.length === 3) {
							this.prjName = parts[0];
							this.domainName = parts[1];
						} else {
							this.prjName = "default";
							this.domainName = parts[0];
						}
					}
				}
				await this.$store.dispatch("get_PrjTemplate", {
					prj: this.prjName,
					domain: this.domainName,
				});
			}
		},
    getRegulation() {
			u.getFileContentLoc(
				this.template.survey.prj,
				this.template.home.regulationHtmlSrc
			).then(
				(ret) => {
					if (ret) {
						this.$store.commit("SET_Regulation", ret);
					}
				},
				(err2) => alert(err2)
			);
		},
    async getTemplateByFullDomain() {
      this.processingApi = true;
			const fullDomain = window.location.host;
			try {
        await this.$store.dispatch("get_templateByFullDomain", { fullDomain });
			} catch (err) {
        await this.getTemplateBySubdomain();
			} finally {
        if (this.template) {
          if (this.template.home.regulationHtmlSrc) {
            this.getRegulation();
					}
					this.setMetaDataFromTemplate();
					this.setDocumentStylesFromTemplate();
				} else {
					document.documentElement.style.setProperty(
						"--bg-fallback-color",
						"#262626"
					);
				}
				if (this.cpf) {
					this.checkStarted();
				}
				this.processingApi = false;
			}
		},
  }
};
</script>

<style scoped>
.bg-terms {
  background-color: var(--bg-fallback-color);
  background-image: var(--bg-image); /* fallback */
  background-image: var(--bg-image), var(--bg-gradient-color); /* W3C */
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  background-attachment: fixed;
  min-height: 100vh;
}

@media screen and (min-width: 900px) {
  .terms-justify {
    text-align: justify;
  }
}

.text-title-regulation, h1 {
  font-size: calc(var(--home-title-size) / 1.5) !important;
}

@media screen and (min-width: 900px) {
  .text-title-regulation {
    font-size: 3rem !important;
  }
}

.back-icon {
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  right: 0;
  bottom: 0;
  margin-bottom: 20px;
  margin-right: 20px;
  margin-left: 35px;
  border-radius: 10px;
  position: fixed;
  z-index: 50;
}

@media (max-width: 700px) {
  .back-icon {
    left: 0;
    margin-bottom: 15px;
    margin-left: 15px;
  }
}

.back-icon:hover {
  cursor: pointer;
  transform: scale(1.05);
  transition: all 0.2s;
}
</style>
